import React from "react";
import "./Product_details.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeadset,
  faLightbulb,
  faTruckFast,
} from "@fortawesome/free-solid-svg-icons";
import { Category } from "../../../utils/common";

const Product_details = ({ variant, product }) => {
  return (
    <>
      <section className="Product_details_sec">
        <div className="row">
          {/* <div className="col-lg-4 col-sm-6">
            <div className="contsec">
              <h6 className="prodtitle">Product Details</h6>
              {product?.Frame_Type?.name && (
                <p className="discp">
                  <span>Frame Type - </span>
                  {product?.Frame_Type?.name}
                </p>
              )}

              {product?.Brand?.name && (
                <p className="discp">
                  <span>Brand - </span>
                  {product?.Brand?.name}
                </p>
              )}
              {product?.Gender?.name && (
                <p className="discp">
                  <span>Gender - </span>
                  {product?.Gender?.name}
                </p>
              )}
              {product?.Shape?.name && (
                <p className="discp">
                  <span>Shape - </span>
                  {product?.Shape?.name}
                </p>
              )}
              {product?.Material?.name && (
                <p className="discp">
                  <span>Material - </span>
                  {product?.Material?.name}
                </p>
              )}
              {product?.Colour?.name && (
                <p className="discp">
                  <span>Frame Colour - </span>
                  {product?.Colour?.name}
                </p>
              )}
              {product?.lens_color?.name && (
                <p className="discp">
                  <span>Lens Colour - </span>
                  {product?.lens_color?.name}
                </p>
              )}
            
              {product?.base_curve && (
                <p className="discp">
                  <span>Base Curve - </span>
                  {product?.base_curve}
                </p>
              )}
              {product?.water_content && (
                <p className="discp">
                  <span>Water Content - </span>
                  {product?.water_content}
                </p>
              )}
              {product?.modality && (
                <p className="discp">
                  <span>Modality - </span>
                  {product?.modality}
                </p>
              )}
              {product?.diameter && (
                <p className="discp">
                  <span>Diameter - </span>
                  {product?.diameter}
                </p>
              )}
              {product?.dk_t && (
                <p className="discp">
                  <span>DK/T -</span>
                  {product?.dk_t}
                </p>
              )}
              {product?.bo_code && (
                <p className="discp">
                  <span>BO Code - </span>
                  {product?.bo_code}
                </p>
              )}
              {product?.size && (
                <p className="discp">
                  <span> {product?.p_category_id === Category.ContactLens? "Pack Size" :"Size"} - </span>
                  {product?.size}
                </p>
              )}

              {product?.total_measurements && (
                <p className="discp">
                  <span>Total Measurements - </span>
                  {product?.total_measurements}
                </p>
              )}
              {product?.description && (
                <p className="discp">
                  <span>Description - </span>
                  {product?.description}
                </p>
              )}

            </div>
          </div> */}
          <div className="col-lg-4 col-sm-6">
            <div className="contsec">
              <h6 className="prodtitle">Question about fit?</h6>
              <p className="discp">
                <span>“Don’t know what suits you better?”</span>
              </p>
              {/* <p className="discp">
                <span>Don't know your size? Learn How</span>
              </p>
              <p className="discp">
                <span>Let our expert opticians help fit you:</span>
              </p> */}
              <p className="discp">
                <span className="me-3">
                  <Link to="/contact-us">
                    <FontAwesomeIcon icon={faHeadset} /> Contact Us
                  </Link>
                </span>{" "}
                <span>
                  <Link to="/quick-quiz">
                    <FontAwesomeIcon icon={faLightbulb} /> Take a Quiz
                  </Link>
                </span>
              </p>
              <p className="discp"></p>
            </div>
          </div>
          <div className="col-lg-4 col-sm-6">
            <div className="contsec">
              <h6 className="prodtitle">Shipping & Returns</h6>
              {/* <p className="discp">
                <span></span>
                {product?.description}
              </p> */}

              <p className="discp">
                <span>
                  <Link to="/shipping-policy">
                    <FontAwesomeIcon icon={faTruckFast} /> Explore Our Shipping
                    & Return Policy
                  </Link>
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Product_details;
